import React from 'react';

const CoreValues = () => {
    return ( 
        <div className='core-values' id='core-values-main'>
            <div className='container'>
                <h4 className='about-section-title' style={{textAlign:'center'}}>OUR CORE VALUES</h4>
                <h2 className='core-title'>Our core values can be summarized by the word <span style={{color:'#4DBBBD'}}>“CRUISE - GPT”</span> which stands for</h2>
            </div>
        </div>
     );
}
 
export default CoreValues;